export default __webpack_public_path__ + "static/media/port2.e9f2d34c.png";